"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function BinaryOptions(_ref) {
  var options = _ref.options,
    selected = _ref.selected,
    onClickOption = _ref.onClickOption,
    disabled = _ref.disabled,
    testIdPrefix = _ref.testIdPrefix;
  return /*#__PURE__*/_react["default"].createElement(_styles.OptionsContainer, {
    "data-cy": testIdPrefix
  }, options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(_styles.OptionWrapper, {
      key: option.id,
      disabled: disabled,
      selected: selected === option.id,
      value: option.value,
      onClick: function onClick() {
        return onClickOption === null || onClickOption === void 0 ? void 0 : onClickOption(option.id);
      },
      "data-cy": "".concat(testIdPrefix, "-").concat(option.value ? 'checked' : 'unchecked')
    }, /*#__PURE__*/_react["default"].createElement(_styles.Icon, {
      value: option.value,
      selected: selected === option.id
    }));
  }));
}
var _default = exports["default"] = BinaryOptions;
//# sourceMappingURL=index.js.map